module.exports = __webpack_public_path__ + "img/IR_on.d9bfaa96.png";